export default {
  // 报图介绍部分，使用drawingsNotice中的重复词汇
  check_drawings_apply: 'Applications of check drawing',
  add_application: 'Apply',
  report_drawings_introduce: 'Introduction',
  application_records: 'Applied records',
  check_status: 'Status',
  btn_modify: 'Modify',
  btn_cancel: 'Cancel',
  btn_continue: 'Continue',
  btn_cancel_submit: 'Cancel',
  producer: 'Producer',
  exhibitor: 'Exhibitor',
  apply_date: 'Created date',
  initial_reporting_time: "Initial reporting time",
  last_update_time: "Last update time",
  get_detail: 'Detail',
  nothing: 'Nothing yet',
  "操作": 'Options',
  no_application: 'No Application',
  // SUBMITTED: '待提交',
  // PENDING: '待审核',
  // VERIFIED: '审核通过',
  // REJECTED: '未通过',
  // CANCELED: '已取消',
  // DISABLED: '已失效',
  cancel_tips_title: 'Cancel confirmation',
  cancel_tips_content: 'You are revoking the current booth report application. The report materials filled after cancellation will not be saved and you will only be able to resubmit. Are you sure you want to perform the undo operation?',
  cancel_success: 'Cancel success',
  cancel_fail: 'Cancel failed, please try again later!',
  net_error: 'There is a small problem on the network, please try again later ^_-',
  "编辑资料": "Edit",
  修改现场人员:'Edit On site personnel',
  "下载审图回执": "Receipt",
  "更多": "More",
  "关闭": "Close",
  "确认取消": "Confirm Cancel",
}



// WEBPACK FOOTER //
// ./src/i18n/en-us/drawings/drawingsIndex.js